class HHMobileMenu extends HTMLElement {
  constructor() {
    super()

    this.submenus = this.querySelectorAll('details')
    this.submenus.forEach((submenu) => {
      submenu.addEventListener('toggle', this.onToggle.bind(this))
    })

    this.onWindowResize = this.setWindowHeightVariable.bind(this)
    this.onModalClosed = this.onMobileMenuClose.bind(this)
    this.onModalOpened = this.onMobileMenuOpen.bind(this)
  }

  connectedCallback() {
    this.setWindowHeightVariable()
    window.addEventListener('resize', this.onWindowResize)
    window.addEventListener('modalOpened', this.onModalOpened)
    window.addEventListener('modalClosed', this.onModalClosed)
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onWindowResize)
    window.removeEventListener('modalOpened', this.onModalOpened)
    window.removeEventListener('modalClosed', this.onModalClosed)
  }

  setWindowHeightVariable() {
    HH.setCSSVariable('--hh-window-height', `${window.innerHeight}px`)
  }

  onToggle(e) {
    if (e.target.hasAttribute('open')) {
      this.setAttribute('submenu-open', true)
    } else {
      this.removeAttribute('submenu-open')
    }
  }

  onMobileMenuOpen(e) {
    const { target } = e
    if (!target.classList?.contains('js-mobile-menu')) return

    const scrollContainer = target.querySelector('.js-mobile-menu-container')
    const innerScrollContainers = scrollContainer?.querySelectorAll('.js-inner-submenu')

    const resetScroll = () => {
      scrollContainer?.scrollTo({ top: 0, behavior: 'auto' })
      innerScrollContainers?.forEach((innerScrollContainer) => {
        console.log(innerScrollContainer)
        innerScrollContainer.scrollTo({ top: 0, behavior: 'auto' })
      })
    }

    resetScroll()
    window.requestAnimationFrame(resetScroll)
  }

  onMobileMenuClose(e) {
    const { target } = e
    if (!target.classList.contains('js-mobile-menu')) return
    this.submenus.forEach((submenu) => submenu.removeAttribute('open'))
  }
}

customElements.define('hh-mobile-menu', HHMobileMenu)
